import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {InventoryTransactionSubLineContainerModel} from '../../../../../../models/aggregates/erp/inventory-transaction';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class InventoryTransactionSubLineService extends BaseApiTemplateService<InventoryTransactionSubLineContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-transactions-sub-line';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-transactions-sub-line';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-transactions-sub-line';
    this.httpClient = http;
  }

}


